export const BNK_STMT_setGlobalOverlayLoaderReducer = {
  BNK_STMT_setGlobalOverlayLoader: (state, action) => {
    state.globalOverlayLoader = action.payload;
  },
};
